import css from './WaitingPlayers.module.css'
import InviteButton from '../InviteButton/InviteButton'
import Label from '../Label/Label'
import Player from '../Name/Player'
import i18next from 'i18next'

function WaitingPlayers({ players, gameId }) {
  return (
    <>
      <Label text={i18next.t('lobby.list.players')} underline={true} />
      <div className={css.WaitingPlayers}>
        {players.map((player) => (
          <Player
            color={player.color}
            id={player.id}
            key={player.id}
            name={player.name}
          />
        ))}

        <div>
          <InviteButton gameId={gameId} />
        </div>
      </div>
    </>
  )
}

export default WaitingPlayers
